import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Row, Col } from 'react-bootstrap';
import PropTypes from "prop-types";
import InputSelect from '../../../../../components/modalComponents/InputSelect';
import GenericModal from '../../../../../components/modal/GenericModal';
import {CustomModalFooter, PrimaryActionButtonForModal} from '../../../styledComponents/styledComponents';
import { useManagePostRequest } from '../../../../../hooks/useManagePostRequest/useManagePostRequest';
import {
    cuadroRequerimientosEditarPlanCurricularCampanaAPI,
    cuadroRequerimientosRegistrarPlanCurricularCampanaAPI
} from '../../../../../consumers/backendApisUrls';
import {useSubmitForm} from "../../../../../hooks/useSubmitForm/useSubmitForm";

const ModalBody = styled.div`
    padding: 20px;
    background-color: #f8f9fa;
`;

const KEYS = {
    IdPlanCurricularCampana : "IdPlanCurricularCampana",
    IdPlanesCurriculares : "IdPlanesCurriculares",
    IdCampana : "IdCampana",
    IdSede : "IdSede"
}

const SECTION_NAME = "AgregarSedeModal"


const AgregarSedeModal = ({ showModal, title, mode, data, campana, listSedes, listPlanes, refetchData }) => {
    const [selectedSede, setSelectedSede] = useState(null);
    const [selectedPlan, setSelectedPlan] = useState([]);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [submitForm] = useSubmitForm();


    const [executeManagePostRequest] = useManagePostRequest();

    const handleChangeSede = (e) => {
        setSelectedSede(e.target.value);
    };

    const handleChangePlan = (e) => {
        setSelectedPlan(e.target.value);
    };



    const handleProcess = async () => {
        if (mode) {
            const payload = {
                IdPlanCurricularCampana: data?.IdPlanCurricularCampana,
                IdPlanesCurriculares: selectedPlan.map(p => p.value)
            };
            await executeManagePostRequest(cuadroRequerimientosEditarPlanCurricularCampanaAPI(),
                payload,
                (res) => {
                    refetchData();
                    showModal();
                }, true,
                (err) => {
                    console.log("error", err);
                }, true
            );
        } else {
           await handleSubmitRegistrar()
        }
    };

    const handleSubmitRegistrar = async (e) => {
        if (e)
            e.preventDefault();

        setIsSubmitting(true);
        let api = "";
        const payload = {
            IdSede: selectedSede?.value,
            IdPlanesCurriculares: selectedPlan.map(p => p.value),
            IdCampana: campana?.IdCampana
        };

        api = cuadroRequerimientosRegistrarPlanCurricularCampanaAPI();

        try {
            await submitForm(Object.values(KEYS), api, payload, SECTION_NAME, successSubmitRegistrarCallback, true);
        } catch (error) {
            console.error(error);
        } finally {
            setIsSubmitting(false);
        }
    }

    const successSubmitRegistrarCallback = async ({data}) => {
        refetchData();
        showModal();
    }


    useEffect(() => {
        if (mode && data) {
            const formatDataSede = [{
                value: data?.IdSede ?? 0,
                label: data?.Sede ?? ''
            }];
            const sede = listSedes.filter(s => formatDataSede.some(f => f.value === s.value));

            const formatDataPlans = (data?.PlanesCurriculares?.map(p => {
                return {
                    value: p?.Value ?? 0,
                    label: p?.Text ?? ''
                }
            }) ?? []);
            const plan = listPlanes.filter(p => formatDataPlans.some(f => f.value === p.value));
            if (sede) setSelectedSede(sede);
            if (plan) setSelectedPlan(plan);
        } else {
            setSelectedSede(null);
            setSelectedPlan([]);
        }
    }, [mode, data, listSedes, listPlanes]);

    return (
        <GenericModal
            showModal={showModal}
            width="500px"
            titulo={title}
        >
            <ModalBody>
                <Row>
                    <Col md={12}>
                        <InputSelect
                            label="Sede"
                            options={listSedes}
                            value={selectedSede}
                            onChange={handleChangeSede}
                            name="IdSede"
                            isRequired={false}
                            direction="row"
                            isDisabled={mode}
                            sectionName={SECTION_NAME}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col md={12}>
                        <InputSelect
                            label="Plan Curricular:"
                            options={listPlanes}
                            value={selectedPlan}
                            onChange={handleChangePlan}
                            name="IdPlanesCurriculares"
                            isRequired={false}
                            direction="row"
                            isMulti={true}
                            sectionName={SECTION_NAME}
                        />
                    </Col>
                </Row>
            </ModalBody>
            <CustomModalFooter>
                <PrimaryActionButtonForModal onClick={handleProcess}>
                    Procesar
                </PrimaryActionButtonForModal>
            </CustomModalFooter>
        </GenericModal>
    );
};

AgregarSedeModal.propTypes = {
    showModal: PropTypes.func.isRequired,
    title: PropTypes.string.isRequired,
    mode: PropTypes.bool.isRequired,
    data: PropTypes.object.isRequired,
    campana: PropTypes.object.isRequired,
    listSedes: PropTypes.array.isRequired,
    listPlanes: PropTypes.array.isRequired,
    refetchData: PropTypes.func.isRequired
};

export default AgregarSedeModal;
